module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner requireEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("需求定制筛选")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "rowsLine clearfix"
  }, [_c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("发布者")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v(_vm._s(_vm.itemDat.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("所属企业")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v(_vm._s(_vm.itemDat.enterpriseName))])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("发布时间")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v(_vm._s(_vm.itemDat.updatedAt))])])]), _vm._v(" "), _c('div', {
    staticClass: "rowsLine clearfix"
  }, [_c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("需求类型")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                          " + _vm._s(_vm.itemDat.demandType) + "\n                       ")])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("预算金额")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                          " + _vm._s(_vm.itemDat.budgetAmount) + "\n                       ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rowsLine clearfix"
  }, [_c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("联系人")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                          " + _vm._s(_vm.itemDat.contactPerson) + "\n                       ")])]), _vm._v(" "), _c('div', {
    staticClass: "iTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                          " + _vm._s(_vm.itemDat.contactPhone) + "\n                       ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rowsLine clearfix"
  }, [_c('div', {
    staticClass: "iTerm textTerm"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("需求内容")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_vm._v("\n                            " + _vm._s(_vm.itemDat.demandContext) + "\n                       ")])])]), _vm._v(" "), _c('div', {
    staticClass: "seekLine"
  }, [_c('span', [_vm._v("企业检索：")]), _vm._v(" "), _c('div', {
    staticClass: "seekGp"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "remote-method": _vm.entSeek,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.entId),
      callback: function($$v) {
        _vm.entId = $$v
      },
      expression: "entId"
    }
  }, _vm._l((_vm.entArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "12px",
      "width": "80px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.entAdd
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabLine"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.entList,
      "header-row-class-name": "tableHead"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "enterpriseName",
      "label": "企业"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "ibtn"
        }, [_c('span', {
          on: {
            "click": function($event) {
              _vm.remove(scope.row)
            }
          }
        }, [_vm._v("删除")])])]
      }
    }])
  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [(_vm.pgState) ? _c('div', {
    staticClass: "loading"
  }, [(_vm.pgState == 1) ? _c('span', [_vm._v("初始化中...")]) : _vm._e(), _vm._v(" "), (_vm.pgState == 2) ? _c('span', [_vm._v("数据保存中...")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.directSave
    }
  }, [_vm._v("保存")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-5efc0b50"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/userMent/requireEdit.vue
// module id = 1504
// module chunks = 1